import React from 'react'
import ScheduleModalBox from '../schedules/common_components/ScheduleModalBox'
import Modal from '../../shared/Modal'

class TimeOffLeaveType extends React.Component {

  constructor(props) {
    super(props)
    const { data } = this.props
    this.state = {
      id: data.id,
      start_date: data.start_date,
      end_date: data.end_date,
      selected_days: data.selected_days,
      oldStartDate: data.selected_days > 0 ? data.start_date : '',
      oldEndDate: data.selected_days > 0 ? data.end_date: '',
      oldSelectedDays: data.selected_days,
      intermittent_dates: [],
      new_selected_days: data.selected_days,
      actual_intermittent_dates: '',
      actual_user_selected_days: data.actual_user_selected_days,
      customized_intermittent_dates: [],
      eligible_leave_end_date: data.eligible_leave_end_date,
      eligible_leave_start_date: data.eligible_leave_start_date,
      configurable: data.configurable,
      configured_by_employee: data.configured_by_employee,
      first_configured_by_ll: !data.configured_by_employee,
      change_detected: false,
      configured_by_ll: !data.configured_by_employee,
      showConfirmationModal: false,
      current_month: '',
      weekdaysToDisable: data.configurable && [] || data.weekdays_to_disable,
      shutdownDates: data.configurable && [] || data.formatted_shutdown_dates,
    }
  }

  componentDidMount() {
    $('[data-toggle="tooltip"]').tooltip()

    const { data } = this.props
    const { eligible_leave_start_date, eligible_leave_end_date, oldSelectedDays } = this.state

    const intermittent_dates = this.buildContinuousIntermittentDates(data.intermittent_dates)
    const actual_intermittent_dates = this.buildContinuousIntermittentDates(data.actual_intermittent_dates)
    const customized_intermittent_dates = !data.configured_by_employee && [] || intermittent_dates
    const choose_actual_dates = data.configurable && !data.configured_by_employee

    this.setState({
      editable: oldSelectedDays === 0,
      intermittent_dates: choose_actual_dates && actual_intermittent_dates || intermittent_dates,
      actual_intermittent_dates: actual_intermittent_dates,
      customized_intermittent_dates: customized_intermittent_dates,
      current_month: intermittent_dates[0] ? moment(intermittent_dates[0].start_date).format('YYYY/MM/DD') : moment(data.eligible_leave_start_date).format('YYYY/MM/DD')
    })
    this.eligibleDates = this.enumerateDaysBetweenDates(eligible_leave_start_date, eligible_leave_end_date)
  }

  componentDidUpdate() {
    this.initializeDatePicker()
    this.initializeCalendars()
    this.titleWeek()
    if (this.state.configurable && this.state.configured_by_ll) {
      this.disableDatePickerClick()
    }
  }

  disableDatePickerClick () {
    const prevent_calendars = [0, 1, 2].map(calendar => {
            return `.intermittent-calendar-${this.state.id}-${calendar} .day, .intermittent-calendar-${this.state.id}-${calendar} .cw`
          }).join()
    $(prevent_calendars).on('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
    });
  }

  initializeCalendars() {
    for (var calendar=0; calendar <= 2; calendar++) {
      this.initializeDatePickerFor(calendar, this.state.id)
      this.bindWeek(calendar)
    }
  }

  titleWeek() {
    let weeks = $('th.cw')
    weeks.each((i) => {
      weeks[i].innerText = "Wk"
    })
  }

  buildContinuousIntermittentDates(intermittent_dates) {
    let continuous_ranges = []
    intermittent_dates.map(range => {
      return {
        start_date: moment(range.start_date).toDate(),
        end_date: moment(range.end_date).toDate()
      }
    }).sort((a, b) => {
      return a.start_date.less_than(b.start_date) ?
        -1 : 1
    }).forEach((range) => {
      let last_date_range = continuous_ranges[continuous_ranges.length - 1]
      if (last_date_range && this.exclusivelyOverlaps(last_date_range, range)) {
        last_date_range.end_date = range.end_date
      } else {
        continuous_ranges.push(range)
      }
    })
    return continuous_ranges
  }

  dateConstraints() {
    return {
      startDate: this.state.eligible_leave_start_date,
      endDate: this.state.eligible_leave_end_date
    }
  }

  initializeDatePicker() {
    const _this = this
    const timeOffId = '.'+this.state.id
    $($(timeOffId).find('.datepicker'))
      .unbind('changeDate')
      .datepicker('destroy')
    $.each($('.datepicker'), () => {
      const options = {...{format: 'yyyy-mm-dd', clearBtn: true}, ..._this.dateConstraints()}
      $($(timeOffId).find('.datepicker')).datepicker(
        options
      ).on('changeDate', (e) => {
        let temp = {}
        let name = $(e.target).data('name')
        let value = e.target.value
        temp[name] = value
        _this.setState(temp)
        $(e.target).datepicker('hide')
      }).keydown(false)
    })
  }

  disabledDatesFor(calendar)  {
    const approxStartOfCalendar = this.defaultDateFor(calendar).startOf('month').add(-1, 'months')
    const approxEndOfCalendar = this.defaultDateFor(calendar).endOf('month').add(1, 'months')
    const approxDatesOfCalendar = this.enumerateDaysBetweenDates(approxStartOfCalendar, approxEndOfCalendar)
    const finalDates = approxDatesOfCalendar.filter(date => this.eligibleDates.indexOf(date) < 0).concat(this.props.data.formatted_shutdown_dates)
    return finalDates
  }

  initializeDatePickerFor(calendar) {
    const calendarClassName = `.intermittent-calendar-${this.state.id}-${calendar}`
    $(calendarClassName).unbind('changeDate').datepicker('destroy')
    const defaultViewDate = this.defaultDateFor(calendar).format('YYYY-MM-DD')
    $(calendarClassName).datepicker({
      format: 'yyyy-mm-dd',
      multidate: true,
      calendarWeeks: true,
      defaultViewDate: defaultViewDate,
      datesDisabled: this.disabledDatesFor(calendar),
      daysOfWeekDisabled: this.props.data.weekdays_to_disable
    })
    $(calendarClassName).addClass('disabled')
    $('.datepicker-switch').removeClass('datepicker-switch')
    this.setDatesFor(calendar)
    $(calendarClassName).on('changeDate', (e) => {
      this.handleIntermittentDaySelection(e, calendar)
    })
  }

  handleIntermittentDaySelection(e, calendar) {
    const calendarDatesKey = `calendar_${this.state.id}_${calendar}_dates`
    const previousDates = gon[calendarDatesKey]
    const selected = previousDates.length < e.dates.length
    let selectedDate
    if (selected) {
      selectedDate = e.date
    } else {
      const deletedDates = previousDates.filter(previousDate => {
        return e.dates.map(date => {
          return moment(date).format('YYYY-MM-DD')
        }).indexOf(previousDate) < 0
      })
      selectedDate = moment(deletedDates[0]).toDate()
    }
    this.handleIntermittentDateChange({start_date: selectedDate, end_date: selectedDate})
  }

  defaultDateFor(calendar) {
    return moment.utc(this.state.current_month).add(calendar, 'months')
  }

  setDatesFor(calendar) {
    const dates = this.extractSelectedDatesFor(calendar)
    if (dates.length > 0) {
      const calendarClassName = `.intermittent-calendar-${this.state.id}-${calendar}`
      $(calendarClassName).datepicker('setDates', dates)
    }
  }

  validDateRange(startDate, endDate) {
    const selectedDates = this.enumerateDaysBetweenDates(startDate, endDate)
    const filterSelectedDates = selectedDates.filter( (d) => {
      return (moment(d).toDate().greater_or_equals(moment(this.state.eligible_leave_start_date).toDate()) && moment(d).toDate().less_or_equals(moment(this.state.eligible_leave_end_date).toDate()))
    })
    return {
      start_date: moment(filterSelectedDates[0]).toDate(),
      end_date: moment(filterSelectedDates[filterSelectedDates.length - 1]).toDate()
    }
  }

  bindWeek(calendar) {
    const calendarWeekClassName = `.intermittent-calendar-${this.state.id}-${calendar} td.cw`
    $(calendarWeekClassName).on('click', (e) => {
      if (this.state.configurable && this.state.configured_by_ll){
        return
      }
      const defaultDate = this.defaultDateFor(calendar)
      const weekNumber = parseInt(e.target.innerText)
      let year;
      if (defaultDate.month() === 0 && weekNumber > 50) {
        year = String(defaultDate.year() - 1)
      } else if (defaultDate.month() === 11 && weekNumber < 5) {
        year = String(defaultDate.year() + 1)
      } else {
        year = String(defaultDate.year())
      }
      const date = year + "-01-01"
      let wn
      if (moment.utc(date).isoWeek() === 53) {
        wn =  weekNumber + 1
      } else {
        wn = weekNumber
      }

      const startOfWeek = moment(moment.utc(date).week(wn).startOf('week').format('YYYY-MM-DD')).toDate()
      const endOfWeek = moment(moment.utc(date).week(wn).endOf('week').format('YYYY-MM-DD')).toDate()
      if (startOfWeek.greater_than(moment(this.state.eligible_leave_end_date).toDate()) || endOfWeek.less_than(moment(this.state.eligible_leave_start_date).toDate())) {
        return null
      }
      const selectedRange = this.validDateRange(startOfWeek, endOfWeek)
      this.handleIntermittentDateChange(selectedRange, calendar, 'week')
    })
  }

  isSelected(dateRange) {
    const rangePresent = this.state.intermittent_dates.map((intermittentRange) => {
      const startDate = intermittentRange.start_date
      const endDate = intermittentRange.end_date
      return dateRange.start_date.between(startDate, endDate) && dateRange.end_date.between(startDate, endDate)
    }).indexOf(true) >= 0
    return !rangePresent
  }

  exclusivelyOverlaps(range1, range2) {
    const startDate1 = moment(range1.start_date)
    const endDate1 = moment(range1.end_date)
    const startDate2 = moment(range2.start_date)
    const endDate2 = moment(range2.end_date)
    return startDate1.diff(endDate2) * startDate2.subtract(1, 'days').diff(endDate1) >= 0
  }

  findOverlappedRanges(selectedRange) {
    let {intermittent_dates} = this.state
    let overlappedRanges = []
    let overlappedIndexes = []
    intermittent_dates.forEach((range, index) => {
      if (this.exclusivelyOverlaps(range, selectedRange)) {
        overlappedRanges.push(range)
        overlappedIndexes.push(index)
      }
    })
    return {overlappedRanges: overlappedRanges, overlappedIndexes: overlappedIndexes}
  }

  pushInIntermittent(selectedRange) {
    let {intermittent_dates} = this.state
    const overlappedRangesDetails = this.findOverlappedRanges(selectedRange)
    let overlappedRanges = overlappedRangesDetails.overlappedRanges
    const overlappedIndexes = overlappedRangesDetails.overlappedIndexes
    overlappedRanges.push(selectedRange)
    const newStartDate = moment.min(
      overlappedRanges.map(range => {
        return moment(range.start_date)
      })
    ).toDate()
    const newEndDate = moment.max(
      overlappedRanges.map(range => {
        return moment(range.end_date)
      })
    ).toDate()
    overlappedIndexes.length && intermittent_dates.splice(overlappedIndexes[0], overlappedIndexes.length)
    intermittent_dates.push({start_date: newStartDate, end_date: newEndDate})
    const built_intermittent_dates = this.buildContinuousIntermittentDates(intermittent_dates)
    this.setState({
      intermittent_dates: built_intermittent_dates,
      customized_intermittent_dates: built_intermittent_dates,
      change_detected: true
    })
    this.fetchSelectedDays(this.state.intermittent_dates)
  }

  popFromIntermittentRange(selectedRange) {
    let {intermittent_dates} = this.state
    const overlappedRangesDetails = this.findOverlappedRanges(selectedRange)
    const overlappedRange = overlappedRangesDetails.overlappedRanges[0]
    const overlappedIndex = overlappedRangesDetails.overlappedIndexes[0]
    intermittent_dates.splice(overlappedIndex, 1)
    if (!overlappedRange.start_date.equals(selectedRange.start_date)) {
      intermittent_dates.push(
        {
          start_date: overlappedRange.start_date,
          end_date: moment(selectedRange.start_date).subtract(1, 'days').toDate()
        }
      )
    }
    if (!overlappedRange.end_date.equals(selectedRange.end_date)) {
      intermittent_dates.push(
        {
          start_date: moment(selectedRange.end_date).add(1, 'days').toDate(),
          end_date: overlappedRange.end_date
        }
      )
    }
    const built_intermittent_dates = this.buildContinuousIntermittentDates(intermittent_dates)
    this.setState({
      intermittent_dates: built_intermittent_dates,
      customized_intermittent_dates: built_intermittent_dates,
      change_detected: true
    })
    this.fetchSelectedDays(this.state.intermittent_dates)
  }

  getSelectedDays() {
    let days = 0
    this.state.intermittent_dates.map(range => {
      const start_date = moment(range.start_date)
      const end_date = moment(range.end_date)
      days += end_date.add(1, 'days').diff(start_date, 'days')
    })
    return days
  }

  getDays() {
    let selected_days = ''
    selected_days = this.state.selected_days + ' day'.pluralize(selected_days, 'noun')
    return (selected_days)
  }

  getWeeksAndDays(days) {
    let week_duration = ''
    let day_duration = ''
    const weeks = Math.floor(days / 7)
    const rem_days = days % 7
    if (weeks > 0) {
      week_duration = weeks + ' week'.pluralize(weeks, 'noun')
    }
    if (rem_days > 0) {
      day_duration = rem_days + ' day'.pluralize(rem_days, 'noun')
    }
    return([week_duration, day_duration].filter(duration => duration).join(' and '))
  }

  handleIntermittentDateChange(selectedRange) {
    const selected = this.isSelected(selectedRange)
    if (selected) {
      this.pushInIntermittent(selectedRange)
    } else {
      this.popFromIntermittentRange(selectedRange)
    }
  }

  extractSelectedDatesFor(calendar) {
    const calendarDate = this.defaultDateFor(calendar)
    const dates = this.state.intermittent_dates.map(range => {
      return this.enumerateDaysBetweenDates(range.start_date, range.end_date)
    }).flatten().filter(date => {
      return moment(date).year() === calendarDate.year() && moment(date).month() === calendarDate.month() && this.state.weekdaysToDisable.indexOf(moment(date).day()) < 0 && this.state.shutdownDates.indexOf(date) < 0
    })
    const calendarDatesKey = `calendar_${this.state.id}_${calendar}_dates`
    gon[calendarDatesKey] = dates
    return dates
  }

  enumerateDaysBetweenDates(startDate, endDate) {
    const currDate = moment(startDate);
    let dates = [currDate.format('YYYY-MM-DD')];
    const lastDate = moment(endDate);
    while(currDate.add(1, 'days').diff(lastDate) <= 0) {
      dates.push(currDate.clone().format('YYYY-MM-DD'));
    }
    return dates;
  }

  previousMonthShowable() {
    const { current_month } = this.state
    const minFirstMonth = moment(this.state.eligible_leave_start_date).toDate()
    const currentFirstMonth = moment(current_month).startOf('month').toDate()
    return currentFirstMonth.greater_than(minFirstMonth)
  }

  showPreviousMonth() {
    let { current_month } = this.state
    if (this.previousMonthShowable()) {
      current_month = moment(current_month).subtract(1, 'month').format('YYYY-MM-DD')
      this.setState({current_month})
    }
  }

  nextMonthShowable() {
    const { current_month } = this.state
    const maxLastMonth = moment(this.state.eligible_leave_end_date).toDate()
    const currentLastMonth = moment(current_month).add(2, 'months').endOf('month').toDate()
    return currentLastMonth.less_than(maxLastMonth)
  }

  showNextMonth() {
    var {current_month} = this.state
    if (this.nextMonthShowable()) {
      current_month = moment(current_month).add(1, 'month').format('YYYY-MM-DD')
      this.setState({current_month})
    }
  }

  start_date() {
    if (this.state.start_date) {
      return moment(this.state.start_date).format(gon.default_date_format_string.toUpperCase());
    } else {
      return '';
    }
  }

  end_date() {
    if (this.state.end_date) {
      return moment(this.state.end_date).format(gon.default_date_format_string.toUpperCase());
    } else {
      return '';
    }
  }

  fetchSelectedDays(dateRange) {
    const rawIntermittentDates = dateRange
    let intermittentDates = []
    rawIntermittentDates.map((date) => {
      intermittentDates.push(
        { start_date: moment(date.start_date).format('YYYY-MM-DD'),
          end_date: moment(date.end_date).format('YYYY-MM-DD')
        }
      )}
    )
    $.ajax({
      url: `/leave_plan_benefits/${this.props.data.lpb_id}/selected_days/`,
      method: 'GET',
      data: { intermittent_dates: JSON.stringify(intermittentDates) },
      dataType: 'JSON',
      success: res => {
        if (res.success) {
          this.setState({
            selected_days: res.user_selected_days,
          });
        }
      }
    });
  }

  handleSubmit(e){
    e.preventDefault()
    if ( this.state.intermittent_dates.length > 0 ) {
      this.setLeaveDates()
    }
    $.ajax({
      url: "/schedules/update_leave_plan_benefit/",
      method: 'PUT',
      dataType: 'JSON',
      data: this.state,
      success: res => {
        if (res.status === "passed") {
          this.props.onTimeOffTypeChange(res.data)
          this.setState({
            oldStartDate: this.state.start_date,
            oldEndDate: this.state.end_date,
            oldSelectedDays: this.state.selected_days,
            editable: this.state.selected_days === 0
          });
          return toastr.success(res.success_message);
        }
        else {
          return toastr.error(res.error_message);
        }
      }
    });
    return (this);
  }

  setLeaveDates() {
    const date_ranges = this.state.intermittent_dates
    const start_date = date_ranges[0].start_date
    const end_date = date_ranges[date_ranges.length - 1].end_date
    this.setState({
      start_date: moment(start_date).format('YYYY-MM-DD'),
      end_date: moment(end_date).format('YYYY-MM-DD')
    })
  }

  timeOffDescription() {
    if (this.props.data.time_off_description) {
      return (
        <p>{this.props.data.time_off_description}</p>
      )
    } else {
      return (
        <div>
          <p>
            You can edit how many days you want to use in your LeavePlan and when you would like to start using them. Be sure to enter a number of days that is consistent with your leave accrual policies and expected days available when you start your leave.
          </p>
        </div>
      )
    }
  }

  handleItemClose() {
    return this.setState({display_modal: false});
  }

  openModalBox(e){
    e.preventDefault();
    return $.getJSON(`/leave_plan_benefits/${this.props.data.item.id}/fetch_details`, data => {
      gon.company_variables = {...gon.company_variables, ...data.statutory_substitutions_options}
      return this.setState({display_modal: true, description: data.description, image_url: data.image_url});
    });
  }

  renderIntermittentDiv() {
    return (
      <div className='flexible-calendar-col'>
        <div className='intermittent-navigators flexible-calendar-row'>
          <div className='show-previous-month'>
            {this.renderPreviousMonthNavigator()}
          </div>
          <div className='show-next-month'>
            {this.renderNextMonthNavigator()}
          </div>
        </div>

        <div className={`flexible-calendar-row intermittent-calendar-row ${this.state.id}`} >
          {this.renderIntermittentCalendars()}
        </div>
      </div>
    )
    $('.datepicker-switch').removeClass('datepicker-switch')
  }

  renderLeaveDates() {
    return (
      this.renderIntermittentDiv(this.state.id)
    )
  }

  renderPreviousMonthNavigator() {
    return this.previousMonthShowable() ?
      (
        <div className='next-prev-span'>
          <span onClick={this.showPreviousMonth.bind(this)}> &lt;&lt;Prev </span>
        </div>
      ) : null
  }

  renderNextMonthNavigator() {
    return this.nextMonthShowable() ?
      (
        <div className='next-prev-span'>
          <span onClick={this.showNextMonth.bind(this)}> Next&gt;&gt; </span>
        </div>
      ) : null
  }

  renderIntermittentCalendars() {
    var calendars = []
    for (var calendar = 0; calendar <= 2; calendar++) {
      calendars.push(this.renderIntermittentCalendar(calendar, ))
    }
    return calendars
  }

  renderIntermittentCalendar (calendar) {
    const disabledDatesClass = this.state.configurable && this.state.configured_by_ll ? 'disabled-dates' : ''
    return (
      <div className={"calendar-with-padding"} key={calendar}>
        <div className={`intermittent-calendar-${this.state.id}-${calendar} ${disabledDatesClass}`} key={`calendar-${this.state.id}-${calendar}`}/>
      </div>
    )
  }

  renderCalendarValues() {
    return (
      <div>
        {this.renderLeaveDates()}
      </div>
    )
  }

  hideCancel() {
    return (this.state.first_configured_by_ll && !this.state.change_detected)
  }

  switchToCustomize(e) {
    e.preventDefault()
    if (this.state.configurable && !this.hideCancel()){
      this.setState({
        configured_by_employee: true,
        configured_by_ll: false,
        intermittent_dates: this.state.customized_intermittent_dates,
        oldSelectedDays: this.state.selected_days
      });
      this.fetchSelectedDays(this.state.customized_intermittent_dates)
    } else {
      this.setState({
        intermittent_dates: this.buildContinuousIntermittentDates(this.props.data.intermittent_dates),
        customized_intermittent_dates: this.buildContinuousIntermittentDates(this.props.data.intermittent_dates)
      })
    }
  }

  renderButtons(){
    let cancelButton = this.state.configurable && this.hideCancel() ? '' : <a href="" onClick={this.switchToCustomize.bind(this)}>Cancel</a>
    if(this.state.editable)
    {
      return(
        <div className="col-md-8 col-md-offset-4">
          <fieldset className="calc-engine-spinner-disabled">
            <div className="confirm-block">
              <button type="submit" className="btn btn-primary btn-darkgray btn-bdr-rds btn-save-time-off-type">
                Save
              </button>
              {cancelButton}
            </div>
          </fieldset>
        </div>
      )
    } else {
      return(
        <div className="col-md-8 col-md-offset-4">
          <fieldset className="calc-engine-spinner-disabled">
            <div className="confirm-block">
              <button type="submit" className="btn btn-primary btn-darkgray btn-bdr-rds btn-save-time-off-type">
                Save
              </button>
              {cancelButton}
            </div>
          </fieldset>
        </div>
      )
    }
  }

  renderNoOfDays() {
    return (
      <div>
        <div className='form-group'>
          <label className='label-control'> Est. Number of Days Used </label>
          <i className="est-days-tooltip fa fa-question-circle" data-toggle="tooltip" title="" data-original-title="Days used are estimated by matching your requested date range with your provided work schedule"></i>
          <label> &nbsp; {this.getDays()} </label>
        </div>
      </div>
    )
  }

  renderModalBox() {
    if (this.state.display_modal) {
      return (
        <ScheduleModalBox
          item={this.props.data.item}
          handleItemClose={this.handleItemClose.bind(this)}
          item_type='benefit_event'
          description={this.state.description}
          image_url={this.state.image_url}
          onHelpfulCheck={this.props.onHelpfulCheck}
        />
      )
    }
  }

  llConfigurator() {
    if (!this.state.configured_by_ll){
      this.setState({
        showConfirmationModal: true
      })
    }
  }

  employeeConfigurator() {
    if (!this.state.configured_by_employee){
      this.setState({
        configured_by_employee: true,
        configured_by_ll: false,
        intermittent_dates: this.state.customized_intermittent_dates,
        oldSelectedDays: this.state.selected_days
      })
      this.fetchSelectedDays(this.state.customized_intermittent_dates)
    }
  }

  benefitControls() {
    let { configurable, configured_by_employee, configured_by_ll, id } = this.state
    return configurable ? (
      <div className='col-md-10'>
          <div className='form-group'>
            <span className='estimated-days pull-left'>
              <label>
                <input
                  type="radio"
                  value="leave_logic"
                  name={`${id + '_benefit_control'}`}
                  checked={configured_by_ll}
                  onClick={this.llConfigurator.bind(this)}
                /> Use default dates
               </label>
            </span>

            <span className='estimated-days pull-right'>
              <label>
                <input
                  type="radio"
                  value="employee"
                  name={`${id + '_benefit_control'}`}
                  checked = {configured_by_employee}
                  onChange={this.employeeConfigurator.bind(this)}
                /> Let me customize the dates
               </label>
            </span>

          </div>
        </div>
      )
    : ''
  }

  hideConfirmationModal() {
    this.setState({ showConfirmationModal: false })
  }

  handleLLCalculation() {
    this.setState({
      showConfirmationModal: false,
      configured_by_employee: false,
      configured_by_ll: true,
      intermittent_dates: this.state.actual_intermittent_dates,
      oldSelectedDays: this.state.actual_user_selected_days,
      selected_days: this.state.actual_user_selected_days
    })
  }

  render() {
    const { showConfirmationModal } = this.state
    return(
      <div className='time-off-type-form'>
        <div className='col-md-6'>
          <div className='form-group'>
            <h4>{`${this.props.data.title + ' '}`}</h4>
            <a
              onClick={this.openModalBox.bind(this)}
              href=''>
              (more details)
            </a>
          </div>
        </div>
        <div className='col-md-4'>
          <span className='estimated-days pull-right'>
            {this.renderNoOfDays()}
          </span>
        </div>
        <div className='col-md-10'>
          <div className='form-group leave-type-edit-info'>
            {this.timeOffDescription()}
          </div>
        </div>
        {this.benefitControls()}
        <div className='col-md-12'>
          <form onSubmit={this.handleSubmit.bind(this)}>
              {this.renderCalendarValues()}
              {this.renderButtons()}
          </form>
        </div>
        {this.renderModalBox()}
        {showConfirmationModal && <Modal show={showConfirmationModal}
                                                hideModalInParent={this.hideConfirmationModal.bind(this)}
                                                title='Reset Benefit'
                                                approve={this.handleLLCalculation.bind(this)}>
                                              <p>Are you sure you want to reset this benefit back to the default dates ?</p>
                                             </Modal>}
        <br></br>
      </div>
    )
  }
}

export default TimeOffLeaveType
